/* eslint-disable no-console */
/* eslint-disable max-classes-per-file */

class AdapterConsole {
  key: string;

  log: {
    (...data: any[]): void;
    (message?: any, ...optionalParams: any[]): void;
  };

  warn: {
    (...data: any[]): void;
    (message?: any, ...optionalParams: any[]): void;
  };

  error: {
    (...data: any[]): void;
    (message?: any, ...optionalParams: any[]): void;
  };

  constructor() {
    this.key = "native";
    this.log = console.log;
    this.warn = console.warn;
    this.error = console.error;
  }
}

class Logger {
  adapter: AdapterConsole;

  log: any;

  warn: any;

  error: any;

  static getAdapter() {
    // TODO it's possible to add a better logger here like goAccess or datadog.
    return new AdapterConsole();
  }

  constructor() {
    this.adapter = Logger.getAdapter();
    this.log = this.adapter.log;
    this.warn = this.adapter.warn;
    this.error = this.adapter.error;
  }
}

export default new Logger();
